import {
  HabitPackFormat,
  MarketplaceEntityFilterValue,
  MarketplaceOwnerFilterValue,
  PackAndFocusEntityType,
  PackEditorMode
} from 'enums';
import {
  FocusModeTemplateType,
  HabitPackType
} from 'interfaces/common.interface';
import {
  PackPreviewType,
  PackPreviewVariant
} from 'interfaces/initial-states.interface';

export const MARKETPLACE_ENTITY_FILTERS = [
  MarketplaceEntityFilterValue.ALL,
  MarketplaceEntityFilterValue.PACKS,
  MarketplaceEntityFilterValue.TEMPLATES
] as const;

export type MarketplaceEntityFilter =
  (typeof MARKETPLACE_ENTITY_FILTERS)[number];

export const MARKETPLACE_OWNER_FILTERS = [
  MarketplaceOwnerFilterValue.EVERYONE,
  MarketplaceOwnerFilterValue.MINE
] as const;

export type MarketplaceOwnerFilter =
  (typeof MARKETPLACE_OWNER_FILTERS)[number];

export type MarketplaceListItem =
  | { kind: PackAndFocusEntityType.HABIT_PACK; habitPack: HabitPackType }
  | {
      kind: PackAndFocusEntityType.FOCUS_TEMPLATE;
      focusTemplate: FocusModeTemplateType;
    };

export interface MarketplaceListSources {
  publicPacks: HabitPackType[];
  publicTemplates: FocusModeTemplateType[];
  userPacks: HabitPackType[];
  userTemplates: FocusModeTemplateType[];
}

export type PickerVariant = PackPreviewVariant;
export type PickerEntityType = PackPreviewType;

export type PackPickerCardProps =
  | {
      entityType: PackAndFocusEntityType.HABIT_PACK;
      habitPack: HabitPackType;
      variant: PickerVariant;
    }
  | {
      entityType: PackAndFocusEntityType.FOCUS_TEMPLATE;
      focusTemplate: FocusModeTemplateType;
      variant: PickerVariant;
    };

export type PackEditorSaveHandler = () => Promise<void>;

export type OpenPackAndFocusEditorParams =
  | {
      type: PackAndFocusEntityType.HABIT_PACK;
      mode: PackEditorMode.CREATE;
      packType: HabitPackFormat.ROUTINE | HabitPackFormat.STANDALONE;
    }
  | {
      type: PackAndFocusEntityType.HABIT_PACK;
      mode: PackEditorMode.EDIT;
      pack: HabitPackType;
    }
  | {
      type: PackAndFocusEntityType.FOCUS_TEMPLATE;
      mode: PackEditorMode.CREATE;
    }
  | {
      type: PackAndFocusEntityType.FOCUS_TEMPLATE;
      mode: PackEditorMode.EDIT;
      template: FocusModeTemplateType;
    };
